var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "nativewind/jsx-runtime";
import { useQuery } from '@tanstack/react-query';
import React, { useState } from 'react';
import { ScreenLayout } from '@/components/ScreenLayout';
import { LogParamsProvider } from '@/logging/LogParamsProvider';
import useAppComponents from '@/hooks/useAppComponents';
import { usePlaceDetailScreenName } from '@/hooks/useFeatureFlags';
import IndoorReviewView from './views/IndoorReviewView';
import ToiletReviewView from './views/ToiletReviewView';
export default function PlaceReviewFormScreen({ route, navigation, }) {
    var _a;
    const { api } = useAppComponents();
    const pdpScreen = usePlaceDetailScreenName();
    const placeId = (_a = route.params) === null || _a === void 0 ? void 0 : _a.placeId;
    const { data } = useQuery({
        queryKey: ['PlaceDetailV2', placeId],
        queryFn: () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            const result = yield api.getPlaceWithBuildingPost({
                placeId: placeId !== null && placeId !== void 0 ? placeId : '',
            });
            return {
                place: result.data.place,
                building: result.data.building,
                isAccessibilityRegistrable: result.data.isAccessibilityRegistrable,
                accessibilityScore: (_a = result.data.accessibilityInfo) === null || _a === void 0 ? void 0 : _a.accessibilityScore,
            };
        }),
    });
    const [reviewType, setReviewType] = useState('indoor');
    const [mobilityTool, setMobilityTool] = useState();
    if (!placeId || typeof placeId !== 'string') {
        return null;
    }
    function gotoPlaceDetail() {
        var _a;
        const state = navigation.getState();
        const currentRouteIndex = state.index;
        const previousRoute = currentRouteIndex > 0 ? state.routes[currentRouteIndex - 1] : null;
        // 이전 화면이 PlaceDetailV2인 경우에만 goBack 사용
        if (navigation.canGoBack() && (previousRoute === null || previousRoute === void 0 ? void 0 : previousRoute.name) === 'PlaceDetailV2') {
            navigation.goBack();
            return;
        }
        // 이전 화면이 PlaceDetail이 아니거나 없는 경우 replace 사용
        navigation.replace(pdpScreen, {
            placeInfo: {
                placeId: (_a = data === null || data === void 0 ? void 0 : data.place) === null || _a === void 0 ? void 0 : _a.id,
            },
        });
    }
    function renderView() {
        switch (reviewType) {
            case 'indoor':
                return (_jsx(IndoorReviewView, { place: data === null || data === void 0 ? void 0 : data.place, gotoPlaceDetail: gotoPlaceDetail, setMobilityTool: setMobilityTool, setReviewTypeToToilet: () => setReviewType('toilet') }));
            case 'toilet':
                return (_jsx(ToiletReviewView, { place: data === null || data === void 0 ? void 0 : data.place, gotoPlaceDetail: gotoPlaceDetail, mobilityTool: mobilityTool }));
        }
    }
    return (_jsx(LogParamsProvider, { params: { placeId }, children: _jsx(ScreenLayout, { safeAreaEdges: ['bottom'], isHeaderVisible: true, className: "bg-white", children: renderView() }) }));
}
